export default __webpack_public_path__ + "static/media/video.4a97cf76.mp4";